import React, { Component } from "react";

import { Icon, Button, Image, Form, Modal } from "semantic-ui-react";

import Spinner from "./spinner";
import Tier from "./tier_component";

import { Column } from "@ant-design/charts";

import { Progress, Tabs, Select, Switch } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import index from "../assets/crisk.png";

import { connect } from "react-redux";

import { project, auth, dashboard, asset } from "../actions";
import { downloadSectionAsImage } from "./download_image";

import ClimateRiskSummary from "./ClimateRiskSummary";

import ClimateRiskKPICards from "./ClimateRiskKPICards";
import StickyClimateFilterHeader from "./StickyClimateFilterHeader";

import { Pie } from "@ant-design/plots";

import "./dashboard.css";

import { Row, Col, Container } from "react-bootstrap";

import RCPDonut from "./rcpdonut";

import YEARDonut from "./yeardonut";

import Classicheatmap from "./classicheatmap";

import Progress_bar from "./progress_bar";

import LossComponent from "./losscomponent";

import PopupMap from "./map1";
import EditableTable from "./table";

import LossPercentComponent from "./loss_percent_component";
import ClusterMap from "./cluster_map";
import KeyFindingModals from "./KeyFindingModals";

const { TabPane } = Tabs;

const columns = [
  {
    tab: "Priority",
    dataIndex: "priority",
    key: "priority",
  },
  {
    tab: "Descritption",
    dataIndex: "description",
    key: "description",
  },
  {
    tab: "Action",
    dataIndex: "",
    render: (_, record) => (
      <Button
        style={{
          boxShadow: "10px 10px 10px #d1d9e6,-10px -10px 10px #f9f9f9",
        }}
      >
        Adaptation Solutions
      </Button>
    ),
  },
];
const { Option } = Select;

let data = [];
let adaptation_data = [];

let options = [];
let Item = [];
let singledata = [];
let data01 = [];
let flat_data = [];

let HazardOptions = [
  /* { key: "River Flood", value: "River Flood", text: "River Flood" },
  { key: "Rainfall Flood", value: "Rainfall Flood", text: "Rainfall Flood" },

  { key: "Drought", value: "Drought", text: "Drought" },
  { key: "Landslide", value: "Landslide", text: "Landslide" },
  { key: "Storm Surge", value: "Storm Surge", text: "Storm Surge" },

  { key: "Extreme heat", value: "Extreme Heat", text: "Extreme heat" },
  { key: "Typhoon", value: "Typhoon", text: "Typhoon" },
  { key: "Snow Fall", value: "Snow Fall", text: "Snow Fall" },
  { key: "Sea Level Rise", value: "Sea Level Rise", text: "Sea Level Rise" },
  { key: "Wild Fire", value: "Wild Fire", text: "Wild Fire" },*/
];
const sectionContainerStyle = {
  paddingLeft: "1rem",
  marginBottom: "2rem",
  borderRadius: "8px",
  border: "1px solid #d9d9d9",
  backgroundColor: "#fff",
};
const currencyOptions = [
  { key: "EUR", value: "EUR", text: "Euro" },
  { key: "USD", value: "USD", text: "US Dollars" },
  { key: "HKD", value: "HKD", text: "HongKong Dollars" },
  { key: "GBP", value: "GBP", text: "Pound" },
];
const MitigationOptions = [
  { key: "River Flood", value: "river_flood", text: "River Flood" },
  { key: "Rainfall Flood", value: "rainfall_flood", text: "Rainfall Flood" },
];
const MitigationMeasureOptions = [
  { key: "No", value: "no", text: "No" },
  { key: "Low", value: "low", text: "Low" },
  { key: "Medium", value: "medium", text: "Medium" },
  { key: "High", value: "high", text: "High" },
];

const ContinentOptions = [];
const FinanceOptions = [
  { key: "financial", value: true, text: "Financial" },
  { key: "percent", value: false, text: "Percentage" },
];
const ContentOptions = [
  { key: "add", value: true, text: "Add Content" },
  { key: "remove", value: false, text: "Remove Content" },
];
const GdpOptions = [
  {
    key: "Unadjusted Operational Loss",
    value: false,
    text: "Unadjusted Operational Loss",
  },
  {
    key: "GDP Adjusted Operational Loss",
    value: true,
    text: "Operational Loss Adjusted with Long-term Climate Change Impact*",
  },
];
const AnalysisOptions = [
  { key: "rcp", value: "rcp", text: "RCP" },
  { key: "ssp", value: "ssp", text: "SSP" },
];

const RcpOptions = [
  { key: 2.6, value: 2.6, text: "2.6" },
  { key: 4.5, value: 4.5, text: "4.5" },
  { key: 8.5, value: 8.5, text: "8.5" },
];
let VariableOptions = [];
let AssetOptions = [];
const YearOptions = [
  { key: 2030, value: 2030, text: 2030 },
  { key: 2050, value: 2050, text: 2050 },
];
const YearOptions_ssp = [
  { key: 2025, value: 2025, text: 2025 },

  { key: 2030, value: 2030, text: 2030 },
  { key: 2035, value: 2035, text: 2035 },
  { key: 2040, value: 2040, text: 2040 },
  { key: 2045, value: 2045, text: 2045 },
  { key: 2050, value: 2050, text: 2050 },
  { key: 2055, value: 2055, text: 2055 },
  { key: 2060, value: 2060, text: 2060 },
  { key: 2065, value: 2065, text: 2065 },
  { key: 2070, value: 2070, text: 2070 },
  { key: 2075, value: 2075, text: 2075 },
  { key: 2080, value: 2080, text: 2080 },
  { key: 2085, value: 2085, text: 2085 },
  { key: 2090, value: 2090, text: 2090 },
  { key: 2095, value: 2095, text: 2095 },
  { key: 2100, value: 2100, text: 2100 },
];

const basementOptions = [
  { key: "yes", value: "yes", text: "yes" },
  { key: "no", value: "no", text: "no" },
  { key: "unknown", value: "unknown", text: "unknown" },
];
const constructionOptions = [
  { key: "wood", value: "wood", text: "wood" },
  { key: "concrete", value: "concrete", text: "concrete" },
  { key: "masonry", value: "masonry", text: "masonry" },
  { key: "xs home", value: "xs home", text: "xs home" },
  { key: "light metal", value: "light metal", text: "light metal" },
  { key: "steel", value: "steel", text: "steel" },
  { key: "unknown", value: "unknown", text: "unknown" },
];
const storiesOptions = [
  { key: 1, value: 1, text: 1 },
  { key: 2, value: 2, text: 2 },
  { key: "3 or More", value: "3 or More", text: "3 or More" },
  { key: "unknown", valeu: "unknown", text: "unknown" },
];
const occupancyOptions = [
  { key: "res", value: "res", text: "res" },
  { key: "com", value: "com", text: "com" },
  { key: "ind", value: "ind", text: "ind" },
  { key: "unknown", value: "unknown", text: "unknown" },
];
const tableOptions = [
  { key: "Top 3", value: 3, text: "Top 3" },
  { key: "Top 5", value: 5, text: "Top 5" },
  { key: "Top 10", value: 10, text: "Top 10" },
];
const CountOptions = [
  { key: "Top 3", value: "Top 3", text: "Top 3" },
  { key: "Top 5", value: "Top 5", text: "Top 5" },
  { key: "All", value: "All", text: "All" },
];
let ParameterOptions = [
  { key: "valuation", value: "valuation", text: "valuation" },
  { key: "loss", value: "loss", text: "Overall Loss" },
];
let mitigationOptions = [
  { key: "yes", value: true, text: "yes" },
  { key: "no", value: false, text: "no" },
];
const valuationOptions = [
  {
    key: "replacement",
    value: "technical_insurance_premium",
    text: "Percentage over Technical Insurance Premium(Replacement Value)",
  },
  {
    key: "valuation",
    value: "asset_value",
    text: "Percentage over Asset Value",
  },
];
let PropertyOptions = [];

class Dashboard extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    activeIndex: 0,
    loading: false,
    lossopen: false,
    heatopen: false,
    mitigation: false,
    articleopen: false,
    percentopen: false,
    edit_permission: "",
    project: "",
    currency: "USD",
    variable: "River Flood",
    rcp: 8.5,
    year: 2050,
    analysis: "ssp",
    modalOpen: false,
    feedback: null,
    asset_table: "",
    table: 3,
    risk: "",
    mitigation_risk: "",
    single_asset: "",
    activeItemName: "",
    single_asset_overall: "",
    singel_asset_chart: "",
    single_asset_loss: "",
    single_asset_loss_2020: "",
    single_asset_inventory: "",
    single_asset_inventory_2020: "",
    single_asset_portfolio_exposure: "",
    single_asset_portfolio_exposure_historic: "",
    adjusted_gdp: false,
    single_asset_progress: "",
    single_asset_cone_chart: "",
    RcpData: "",
    YearData: "",
    basement: "yes",
    construction: "wood",
    stories: "1",
    occupancy: "res",
    per_sq_m_value: 40000,
    scatter: "",
    yearDetail: "",
    detailed: false,
    global: false,
    metigation: "",
    metigation_measure: "high",
    singleYearDetail: "",
    portfolio_losses: "",
    portfolio_losses_flat: "",
    overall: "",
    heatmap: "",
    heatmap_bi: "",
    heatmap_without_adaptation: "",
    losses: "",
    data: "",
    financial: true,
    mapVariable: "FL8570",
    adaptationIntensity: true,
    adaptationHeatmap: true,
    assets: [],
    typhoon_map_data: "",
    mapAsset: "",
    table_condition: false,
    oldname: "",
    newname: "",
    area: "",
    type: "",
    valuation: "",
    count: "All",
    subscription: "",
    singlePercentage: "",
    parameter: "loss",
    Million: true,
    exposure_variable: "Total",
    hazard_map_data: "",
    hazard_map_data_with_continent: "",
    property_type: "NA",
    long: "",
    mitigation_info: false,
    lat: "",
    combined_data: "",
    hazard_continent: "",
    zoom: 14,
    continent: "asia",
    activeIndex: -1,
    mitigation_variable: "river_flood",
    percentage: "",
    variables: "",
    property_types: "NA",
    country_loss: "",
    countryloss: "",
    with_content: false,
    ssp: 8.5,
    defaultbuilding: "",
    riskOpen: false,
    worldmap: false,
    risk_2020: "",
    risk_2020_without_adaptation: "",
    losses_2020: "",
    inventory: "",
    inventory_2020: "",
    filterOpen: false,
    hazard: "",
    hazard_without_adaptation: "",
    hazard_map: "Typhoon",
    floors: "",
    use_valuation: "asset_value",
    ownership: "",
    construction_cost: "",
    revenue: "",
    Cvar: false,
    FilterInfo: false,
    key_finding_data: "",
    priority: false,
    key_finding_1: false,
    key_finding_2: false,
    key_finding_3: false,
    key_finding_p: false,
    key_finding_t: false,
    card_finding_1: false,
    card_finding_2: false,
    card_finding_3: false,
    card_finding_4: false,
    card_finding_5: false,
    card_finding_6: false,
    info_table: false,
    single_asset_hazard: "",
    single_asset_hazard_2020: "",
    single_asset_hazard_without_adaptation: "",
    single_asset_hazard_2020_without_adaptation: "",
    portfolio_exposure: "",
    portfolio_exposure_historic: "",
    climate_risk_card_data: "",
    single_climate_risk_card_data: "",
    single_asset_climate_score: "",
  };

  handleAdaptationToggleIntensity = (checked) => {
    this.setState({ adaptationIntensity: checked });
  };

  handleAdaptationToggleHeatmap = (checked) => {
    this.setState({ adaptationHeatmap: checked });
  };

  handleKeyFindings_1 = () => {
    this.setState({
      key_finding_1: true,
    });
  };
  handleKeyFindings_2 = () => {
    this.setState({
      key_finding_2: true,
    });
  };
  handleKeyFindings_3 = () => {
    this.setState({
      key_finding_3: true,
    });
  };
  handleKeyFindings_p = () => {
    this.setState({
      key_finding_p: true,
    });
  };
  handleKeyFindings_t = () => {
    this.setState({
      key_finding_t: true,
    });
  };
  handleCardFindings_1 = () => {
    this.setState({
      card_finding_1: true,
    });
  };
  handleCardFindings_2 = () => {
    this.setState({
      card_finding_2: true,
    });
  };
  handleCardFindings_3 = () => {
    this.setState({
      card_finding_3: true,
    });
  };
  handleCardFindings_4 = () => {
    this.setState({
      card_finding_4: true,
    });
  };
  handleKeyFindings_4 = () => {
    this.setState({
      info_table: true,
    });
  };
  handleCardFindings_5 = () => {
    this.setState({
      card_finding_5: true,
    });
  };
  handleCardFindings_6 = () => {
    this.setState({
      card_finding_6: true,
    });
  };
  handleKeyFindings_5 = () => {
    this.setState({
      info_table: true,
    });
  };
  handlepriority = () => {
    this.setState({
      priority: true,
    });
  };
  MitigationInfo = () => {
    this.setState({
      mitigation_info: true,
    });
  };

  handleCardClose = () => {
    this.setState({
      card_finding_1: false,
      card_finding_2: false,

      card_finding_3: false,
      card_finding_4: false,
      card_finding_5: false,
      card_finding_6: false,
      priority: false,
    });
  };

  handleKeyClose = () => {
    this.setState({
      key_finding_1: false,
      key_finding_2: false,
      key_finding_3: false,
      key_finding_p: false,
      key_finding_t: false,
      info_table: false,
    });
  };
  FilterInfo = () => {
    this.setState({
      FilterInfo: true,
    });
  };
  FilterInfoClose = () => {
    this.setState({
      FilterInfo: false,
    });
  };
  handleCvar = () => {
    this.setState({
      Cvar: true,
    });
  };
  handleLossOpen = () => {
    this.setState({
      lossopen: true,
    });
  };
  handleArticleOpen = () => {
    this.setState({
      articleopen: true,
    });
  };
  handlePercentOpen = () => {
    this.setState({
      percentopen: true,
    });
  };
  handleHeatOpen = () => {
    this.setState({
      heatopen: true,
    });
  };
  handleRiskOpen = () => {
    this.setState({
      riskOpen: true,
    });
  };
  RiskClose = () => {
    this.setState({
      riskOpen: false,
    });
  };
  handleFilterOpen = () => {
    this.setState({
      filterOpen: true,
    });
  };
  filterClose = () => {
    this.setState({
      filterOpen: false,
    });
  };
  lossClose = () => {
    this.setState({
      lossopen: false,
    });
  };
  percentClose = () => {
    this.setState({
      percentopen: false,
    });
  };
  heatClose = () => {
    this.setState({
      heatopen: false,
    });
  };
  articleClose = () => {
    this.setState({
      articleopen: false,
    });
  };
  CvarClose = () => {
    this.setState({
      Cvar: false,
    });
  };
  MitigationClose = () => {
    this.setState({
      mitigation_info: false,
    });
  };

  componentDidMount() {
    const feedback = this.props.feedback;
    const overall = feedback?.overall;

    if (
      overall &&
      (this.state.analysis === "rcp" || this.state.analysis === "ssp")
    ) {
      const assetTable = overall.asset_table || [];
      const firstAsset = assetTable[0] || {};

      this.setState(
        {
          subscription: feedback.tier_permissions,
          feedback: overall.overall_bar_chart,
          asset_table: assetTable,
          climate_risk_card_data: overall.climate_risk_card_data,
          risk_2020: overall.hazard_values_2020,
          risk_2020_without_adaptation:
            overall.hazard_values_2020_without_adaptation,
          losses: overall.loss_bars_data,
          portfolio_exposure: overall.portfolio_exposure_percentage_loss,
          portfolio_exposure_historic:
            overall.portfolio_exposure_percentage_loss_historic,
          edit_permission: feedback.data_edit_permissions,
          metigation: overall.metigation_measures,
          losses_2020: overall.loss_bars_data_historic,
          inventory: overall.inventory_loss_data,
          inventory_2020: overall.inventory_loss_data_historic,
          single_asset: feedback.single_asset,
          hazard: overall.hazard_values,
          hazard_without_adaptation: overall.hazard_values_without_adaptation,
          typhoon_map_data: overall.typhoon_map_data,
          overall: overall,
          combined_data: overall.combined_data,
          heatmap: overall.heatmap,
          heatmap_bi: overall.heatmap_bi_days,
          heatmap_without_adaptation: overall.heatmap_without_adaptation,
          lat: firstAsset.latitude,
          long: firstAsset.longitude,
          percentage: overall.year_chart_data?.percentage,
          yearDetail: overall.bar_chart_data,
          country_loss: overall.country_wise_loss_data,
          hazard_continent: overall.hazard_map_continents,
          hazard_map_data: overall.hazard_map_data,
          hazard_map_data_with_continent:
            overall.hazard_map_data_with_continent,
          key_finding_data: overall.key_finding_data,
        },
        () => {
          this.setState({ table_condition: true });
          localStorage.setItem("with_content", this.state.with_content);
        }
      );
    }

    this.setState({ assets: this.props.assets });
    console.log("Called Again");
    this.props.getAssets();
    this.props.getProjectList("physical_risk");

    let formdata = new FormData();
    if (
      this.props.location.state !== null &&
      this.props.location.state.project_name.project
    ) {
      formdata.append(
        "project_name",
        this.props.location.state.project_name.project
      );
      formdata.append(
        "project_id",
        this.props.location.state.project_name.project_id
      );
      formdata.append(
        "scenario",
        this.props.location.state.project_name.default_filters.scenario
      );
      formdata.append("variable", this.state.exposure_variable);
      formdata.append(
        "year",
        this.props.location.state.project_name.default_filters.year
      );
      formdata.append("currency", this.state.currency);
      formdata.append("count", this.state.count);
      formdata.append("percentage_type", this.state.use_valuation);

      formdata.append("mitigation", this.state.mitigation);
      formdata.append(
        "analysis_type",
        this.props.location.state.project_name.default_filters.analysis_type
      );
      formdata.append("parameter", this.state.parameter);
      formdata.append("with_content", this.state.with_content);
      formdata.append("adjusted_gdp", this.state.adjusted_gdp);
      formdata.append("property_type", this.state.property_type);

      this.setState(
        {
          project: this.props.location.state.project_name.project,
          rcp: this.props.location.state.project_name.default_filters.scenario,
          ssp: this.props.location.state.project_name.default_filters.scenario,
          analysis: this.props.location.state.project_name.default_filters
            .analysis_type,
          year: this.props.location.state.project_name.default_filters.year,
          variables: this.props.location.state.project_name.variables,
          property_types: this.props.location.state.project_name.property_types,
        },
        () => this.props.addDashboard(formdata)
      );
    } else if (
      this.props.location.state !== null &&
      this.props.location.state.project_name
    ) {
      formdata.append("project_name", this.props.location.state.project_name);
      formdata.append("project_id", this.props.location.state.project_id);
      formdata.append("scenario", this.props.location.state.rcp);
      formdata.append("percentage_type", this.state.use_valuation);
      formdata.append("currency", this.state.currency);
      formdata.append("variable", this.state.exposure_variable);
      formdata.append("year", this.props.location.state.year);
      formdata.append("mitigation", this.state.mitigation);
      formdata.append("count", this.state.count);
      formdata.append("analysis_type", this.props.location.state.scenario);
      formdata.append("parameter", this.state.parameter);
      formdata.append("adjusted_gdp", this.state.adjusted_gdp);
      formdata.append("with_content", this.state.with_content);
      formdata.append("property_type", this.state.property_type);

      this.setState(
        {
          project: this.props.location.state.project_name,
          variables: this.props.location.state.variables,
          rcp: this.props.location.state.rcp,
          ssp: this.props.location.state.rcp,
          analysis: this.props.location.state.scenario,
          year: this.props.location.state.year,
          property_types: this.props.location.state.property_type,
        },
        () => this.props.addDashboard(formdata)
      );
    } else if (this.props.location.state == null) {
      this.props.history.push({
        pathname: "/location",
      });
    }

    let formdata1 = new FormData();
    if (
      this.props.location.state !== null &&
      this.props.location.state.project_name.project
    ) {
      formdata1.append(
        "project",
        this.props.location.state.project_name.project
      );
      formdata1.append("rcp", this.state.rcp);
      formdata1.append("year", this.state.year);
      formdata1.append("count", this.state.count);
      formdata1.append("with_content", this.state.with_content);

      formdata1.append("variable", this.state.exposure_variable);

      this.props.getDetailByYear(formdata1);
    } else if (
      this.props.location.state !== null &&
      this.props.location.state.project_name
    ) {
      formdata1.append("project", this.props.location.state.project_name);
      formdata1.append("rcp", this.state.rcp);
      formdata1.append("count", this.state.count);
      formdata1.append("with_content", this.state.with_content);

      formdata1.append("variable", this.state.exposure_variable);
      formdata1.append("year", this.state.year);

      this.props.getDetailByYear(formdata1);
    } else if (this.props.location.state == null) {
      this.props.history.push({
        pathname: "/location",
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const feedback = this.props.feedback;
    const overall = feedback?.overall;

    // Common conditions
    const isRcp = this.state.analysis === "rcp";
    const isSsp = this.state.analysis === "ssp";

    const assetTable = overall?.asset_table || [];
    const firstAsset = assetTable[0] || {};

    // Only proceed if feedback and overall exist
    if (
      prevProps.feedback !== feedback &&
      overall &&
      (this.state.analysis === "rcp" || this.state.analysis === "ssp")
    ) {
      console.log("Setting state now ......");
      this.setState(
        {
          subscription: feedback.tier_permissions,
          feedback: overall.overall_bar_chart,
          asset_table: assetTable,
          climate_risk_card_data: overall.climate_risk_card_data,
          risk_2020: overall.hazard_values_2020,
          risk_2020_without_adaptation:
            overall.hazard_values_2020_without_adaptation,
          heatmap_without_adaptation: overall.heatmap_without_adaptation,
          hazard_without_adaptation: overall.hazard_values_without_adaptation,

          losses: overall.loss_bars_data,
          portfolio_exposure: overall.portfolio_exposure_percentage_loss,
          portfolio_exposure_historic:
            overall.portfolio_exposure_percentage_loss_historic,
          edit_permission: feedback.data_edit_permissions,
          metigation: overall.metigation_measures,
          losses_2020: overall.loss_bars_data_historic,
          inventory: overall.inventory_loss_data,
          inventory_2020: overall.inventory_loss_data_historic,
          single_asset: feedback.single_asset,
          hazard: overall.hazard_values,
          typhoon_map_data: overall.typhoon_map_data,
          overall: overall,
          combined_data: overall.combined_data,
          heatmap: overall.heatmap,
          heatmap_bi: overall.heatmap_bi_days,
          lat: firstAsset.latitude,
          long: firstAsset.longitude,
          percentage: overall.year_chart_data?.percentage,
          yearDetail: overall.bar_chart_data,
          country_loss: overall.country_wise_loss_data,
          hazard_continent: overall.hazard_map_continents,
          hazard_map_data: overall.hazard_map_data,
          hazard_map_data_with_continent:
            overall.hazard_map_data_with_continent,
          key_finding_data: overall.key_finding_data,
        },
        () => {
          this.setState({ table_condition: true });
          localStorage.setItem("with_content", this.state.with_content);
        }
      );
    }

    if (prevProps.assets !== this.props.assets) {
      console.log("user assets", this.props.assets);
      this.setState({ assets: this.props.assets });
    }
  }

  Edit = (assetsArray) => {
    let formdata = new FormData();
    formdata.append("project_name", this.state.project);

    formdata.append("assets", JSON.stringify(assetsArray));

    this.setState({ loading: true }, () =>
      this.props.updateAsset(formdata, this.AssetEditCallback)
    );
  };
  AssetEditCallback = (success) => {
    if (success) {
      this.setState({ loading: false }, () => {
        this.handleSubmitPro(); // call after state is updated
      });
    }
  };

  handleProject = (e, { value }) => {
    this.setState({ project: value }, () => console.log(this.state.project));
  };

  handleRCP = (e, { value }) => {
    this.setState({ rcp: value }, () => console.log(this.state.rcp));
  };
  handleVariable = (e, { value }) => {
    this.setState({ mapVariable: value });
  };

  handleYear = (e, { value }) => {
    this.setState({ year: value }, () => console.log(this.state.year));
  };
  handleLogout = () => {
    this.props.logout();
  };
  handleOpen = (asset) => {
    let buildingData = this.state.asset_table.filter(
      (building) => building.name == asset
    );

    this.setState(
      {
        modalOpen: true,
        defaultbuilding: buildingData,
        activeItemName: asset,
      },
      this.handleSingleAsset
    );
  };

  handleClose = () => this.setState({ modalOpen: false });

  handleSingleAsset = () => {
    const { single_asset, activeItemName, analysis } = this.state;

    if (single_asset.length > 0) {
      const Item = single_asset.filter(
        (asset) => asset.asset_name === activeItemName
      );

      if (Item.length > 0) {
        this.setState({ single_asset_overall: Item }, this.handleSingleChart);

        console.log(
          "single asset opening",
          this.state.single_asset_overall,
          activeItemName
        );

        if (analysis === "rcp" || analysis === "ssp") {
          this.setState({
            singleYearDetail: Item[0].bar_chart_data,
            //singlePercentage: Item[0].year_chart_data.percentage,
            mapAsset: Item[0],
          });
        }
      }
    }
  };

  handleSingleChart = () => {
    singledata = [
      {
        name: "2020",
        "RCP2.6": 0,
        "RCP4.5": 0,
        "RCP8.5": this.state.single_asset_overall[0].overall_bar_chart["2020"],
      },

      {
        name: "2030",
        "RCP2.6": this.state.single_asset_overall[0].overall_bar_chart[
          "2030_26"
        ],
        "RCP4.5": this.state.single_asset_overall[0].overall_bar_chart[
          "2030_45"
        ],
        "RCP8.5": this.state.single_asset_overall[0].overall_bar_chart[
          "2030_85"
        ],
      },

      {
        name: "2050",
        "RCP2.6": this.state.single_asset_overall[0].overall_bar_chart[
          "2050_26"
        ],
        "RCP4.5": this.state.single_asset_overall[0].overall_bar_chart[
          "2050_45"
        ],
        "RCP8.5": this.state.single_asset_overall[0].overall_bar_chart[
          "2050_85"
        ],
      },
    ];

    this.setState(
      {
        singel_asset_chart: singledata,
        single_asset_hazard: this.state.single_asset_overall[0].hazard_values,
        single_asset_hazard_2020: this.state.single_asset_overall[0]
          .hazard_values_2020,
        single_asset_hazard_without_adaptation: this.state
          .single_asset_overall[0].hazard_values_without_adaptation,
        single_asset_hazard_2020_without_adaptation: this.state
          .single_asset_overall[0].hazard_values_2020_without_adaptation,
        single_asset_loss: this.state.single_asset_overall[0].loss_bars_data,
        single_asset_loss_2020: this.state.single_asset_overall[0]
          .loss_bars_data_historic,
        single_asset_inventory: this.state.single_asset_overall[0]
          .inventory_loss_data,
        single_asset_inventory_2020: this.state.single_asset_overall[0]
          .inventory_loss_data_historic,
        single_asset_portfolio_exposure: this.state.single_asset_overall[0]
          .portfolio_exposure_percentage_loss,
        single_asset_climate_score: this.state.single_asset_overall[0]
          .per_10_years_rise,
        single_asset_portfolio_exposure_historic: this.state
          .single_asset_overall[0].portfolio_exposure_percentage_loss_historic,
        //single_asset_progress: this.state.single_asset_overall[0].progress_bars,
        //single_asset_progress_2020:
        //this.state.single_asset_overall[0].progress_bars_2020,
        single_asset_cone_chart: this.state.single_asset_overall[0].cone_chart,
        single_climate_risk_card_data: this.state.single_asset_overall[0]
          .climate_risk_card_data,
      },
      this.handleComparison
    );
  };

  handleComparison = () => {
    let RcpData = [
      {
        name: 2.6,
        variable: "OVERALL",
        index: this.state.single_asset_cone_chart.cone1_26["OVERALL"],
      },

      {
        name: 2.6,
        variable: "River Flood",
        index: this.state.single_asset_cone_chart.cone1_26.both["River Flood"],
      },
      {
        name: 2.6,
        variable: "Drought",
        index: this.state.single_asset_cone_chart.cone1_26.both["Drought"],
      },

      {
        name: 2.6,
        variable: "Storm Surge",
        index: this.state.single_asset_cone_chart.cone1_26.both["Storm Surge"],
      },
      {
        name: 2.6,
        variable: "Landslide",
        index: this.state.single_asset_cone_chart.cone1_26.both["Landslide"],
      },

      {
        name: 2.6,
        variable: "Extreme Heat",
        index: this.state.single_asset_cone_chart.cone1_26.both["Extreme heat"],
      },
      {
        name: 2.6,
        variable: "Rainfall Flood",
        index: this.state.single_asset_cone_chart.cone1_26.both[
          "Rainfall Flood"
        ],
      },
      {
        name: 2.6,
        variable: "Snowfall",
        index: this.state.single_asset_cone_chart.cone1_26.both["Snow Fall"],
      },
      {
        name: 2.6,
        variable: "Sea Level Rise",
        index: this.state.single_asset_cone_chart.cone1_26.both[
          "Sea Level Rise"
        ],
      },
      {
        name: 2.6,
        variable: "Typhoon",
        index: this.state.single_asset_cone_chart.cone1_26.both["Typhoon"],
      },
      {
        name: 4.5,
        variable: "OVERALL",
        index: this.state.single_asset_cone_chart.cone1_45["OVERALL"],
      },

      {
        name: 4.5,
        variable: "River Flood",
        index: this.state.single_asset_cone_chart.cone1_45.both["River Flood"],
      },
      {
        name: 4.5,
        variable: "Drought",
        index: this.state.single_asset_cone_chart.cone1_45.both["Drought"],
      },

      {
        name: 4.5,
        variable: "Storm Surge",
        index: this.state.single_asset_cone_chart.cone1_45.both["Storm Surge"],
      },
      {
        name: 4.5,
        variable: "Landslide",
        index: this.state.single_asset_cone_chart.cone1_45.both["Landslide"],
      },

      {
        name: 4.5,
        variable: "Extreme Heat",
        index: this.state.single_asset_cone_chart.cone1_45.both["Extreme heat"],
      },
      {
        name: 4.5,
        variable: "Rainfall Flood",
        index: this.state.single_asset_cone_chart.cone1_45.both[
          "Rainfall Flood"
        ],
      },
      {
        name: 4.5,
        variable: "Snowfall",
        index: this.state.single_asset_cone_chart.cone1_45.both["Snow Fall"],
      },
      {
        name: 4.5,
        variable: "Sea Level Rise",
        index: this.state.single_asset_cone_chart.cone1_45.both[
          "Sea Level Rise"
        ],
      },
      {
        name: 4.5,
        variable: "Typhoon",
        index: this.state.single_asset_cone_chart.cone1_45.both["Typhoon"],
      },
      {
        name: 8.5,
        variable: "OVERALL",
        index: this.state.single_asset_cone_chart.cone1_85["OVERALL"],
      },

      {
        name: 8.5,
        variable: "River Flood",
        index: this.state.single_asset_cone_chart.cone1_85.both["River Flood"],
      },
      {
        name: 8.5,
        variable: "Drought",
        index: this.state.single_asset_cone_chart.cone1_85.both["Drought"],
      },

      {
        name: 8.5,
        variable: "Storm Surge",
        index: this.state.single_asset_cone_chart.cone1_85.both["Storm Surge"],
      },
      {
        name: 8.5,
        variable: "Landslide",
        index: this.state.single_asset_cone_chart.cone1_85.both["Landslide"],
      },

      {
        name: 8.5,
        variable: "Extreme Heat",
        index: this.state.single_asset_cone_chart.cone1_85.both["Extreme heat"],
      },
      {
        name: 8.5,
        variable: "Rainfall Flood",
        index: this.state.single_asset_cone_chart.cone1_85.both[
          "Rainfall Flood"
        ],
      },
      {
        name: 8.5,
        variable: "Snowfall",
        index: this.state.single_asset_cone_chart.cone1_85.both["Snow Fall"],
      },
      {
        name: 8.5,
        variable: "Sea Level Rise",
        index: this.state.single_asset_cone_chart.cone1_85.both[
          "Sea Level Rise"
        ],
      },
      {
        name: 8.5,
        variable: "Typhoon",
        index: this.state.single_asset_cone_chart.cone1_85.both["Typhoon"],
      },
    ];
    let max = this.state.single_asset_cone_chart.year_max;

    let RcpConfig = {
      data: RcpData,
      isGroup: true,
      yAxis: {
        max: max + 0.2 * max,
      },
      xField: "variable",
      yField: "index",
      seriesField: "name",
      colorField: "name",

      legend: false,
      label: {
        position: "top",
      },
      color: ["#2077b4", "#FE6702", "#4da02d"],
    };
    if (this.state.analysis == "rcp") {
      let yearData = [
        {
          name: 2020,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_20["OVERALL"],
        },

        {
          name: 2020,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "River Flood"
          ],
        },
        {
          name: 2020,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_20.both["Drought"],
        },

        {
          name: 2020,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Storm Surge"
          ],
        },
        {
          name: 2020,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_20.both["Landslide"],
        },

        {
          name: 2020,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Extreme heat"
          ],
        },
        {
          name: 2020,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2020,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_20.both["Snow Fall"],
        },
        {
          name: 2020,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2020,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_20.both["Typhoon"],
        },
        {
          name: 2030,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_30["OVERALL"],
        },

        {
          name: 2030,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "River Flood"
          ],
        },
        {
          name: 2030,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_30.both["Drought"],
        },

        {
          name: 2030,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Storm Surge"
          ],
        },
        {
          name: 2030,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_30.both["Landslide"],
        },

        {
          name: 2030,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Extreme heat"
          ],
        },
        {
          name: 2030,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2030,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_30.both["Snow Fall"],
        },
        {
          name: 2030,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2030,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_30.both["Typhoon"],
        },
        {
          name: 2050,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_50["OVERALL"],
        },

        {
          name: 2050,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "River Flood"
          ],
        },
        {
          name: 2050,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_50.both["Drought"],
        },

        {
          name: 2050,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Storm Surge"
          ],
        },
        {
          name: 2050,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_50.both["Landslide"],
        },

        {
          name: 2050,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Extreme heat"
          ],
        },
        {
          name: 2050,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2050,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_50.both["Snow Fall"],
        },
        {
          name: 2050,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2050,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_50.both["Typhoon"],
        },
      ];
      let max = this.state.single_asset_cone_chart.scenario_max;

      let yearConfig = {
        data: yearData,
        color: ["#f47a7b", "#8cb0f8", "#18202F"],
        yAxis: {
          max: max + 0.2 * max,
        },
        legend: false,
        isGroup: true,
        xField: "variable",
        colorField: "name",

        yField: "index",
        seriesField: "name",

        label: {
          position: "top",
        },
      };
      this.setState({ YearData: yearConfig });
    } else if (this.state.analysis == "ssp") {
      let yearData = [
        {
          name: 2020,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_20["OVERALL"],
        },

        {
          name: 2020,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "River Flood"
          ],
        },
        {
          name: 2020,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_20.both["Drought"],
        },

        {
          name: 2020,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Storm Surge"
          ],
        },
        {
          name: 2020,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_20.both["Landslide"],
        },

        {
          name: 2020,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Extreme heat"
          ],
        },
        {
          name: 2020,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2020,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_20.both["Snow Fall"],
        },
        {
          name: 2020,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_20.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2020,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_20.both["Typhoon"],
        },
        {
          name: 2030,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_30["OVERALL"],
        },

        {
          name: 2030,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "River Flood"
          ],
        },
        {
          name: 2030,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_30.both["Drought"],
        },

        {
          name: 2030,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Storm Surge"
          ],
        },
        {
          name: 2030,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_30.both["Landslide"],
        },

        {
          name: 2030,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Extreme heat"
          ],
        },
        {
          name: 2030,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2030,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_30.both["Snow Fall"],
        },
        {
          name: 2030,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_30.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2030,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_30.both["Typhoon"],
        },
        {
          name: 2050,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_50["OVERALL"],
        },

        {
          name: 2050,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "River Flood"
          ],
        },
        {
          name: 2050,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_50.both["Drought"],
        },

        {
          name: 2050,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Storm Surge"
          ],
        },
        {
          name: 2050,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_50.both["Landslide"],
        },

        {
          name: 2050,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Extreme heat"
          ],
        },
        {
          name: 2050,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2050,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_50.both["Snow Fall"],
        },
        {
          name: 2050,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_50.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2050,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_50.both["Typhoon"],
        },
        {
          name: 2100,
          variable: "OVERALL",
          index: this.state.single_asset_cone_chart.cone3_100.both["OVERALL"],
        },

        {
          name: 2100,
          variable: "River Flood",
          index: this.state.single_asset_cone_chart.cone3_100.both[
            "River Flood"
          ],
        },
        {
          name: 2100,
          variable: "Drought",
          index: this.state.single_asset_cone_chart.cone3_100.both["Drought"],
        },

        {
          name: 2100,
          variable: "Storm Surge",
          index: this.state.single_asset_cone_chart.cone3_100.both[
            "Storm Surge"
          ],
        },
        {
          name: 2100,
          variable: "Landslide",
          index: this.state.single_asset_cone_chart.cone3_100.both["Landslide"],
        },

        {
          name: 2100,
          variable: "Extreme Heat",
          index: this.state.single_asset_cone_chart.cone3_100.both[
            "Extreme heat"
          ],
        },
        {
          name: 2100,
          variable: "Rainfall Flood",
          index: this.state.single_asset_cone_chart.cone3_100.both[
            "Rainfall Flood"
          ],
        },
        {
          name: 2100,
          variable: "Snowfall",
          index: this.state.single_asset_cone_chart.cone3_100.both["Snow Fall"],
        },
        {
          name: 2100,
          variable: "Sea Level Rise",
          index: this.state.single_asset_cone_chart.cone3_100.both[
            "Sea Level Rise"
          ],
        },
        {
          name: 2100,
          variable: "Typhoon",
          index: this.state.single_asset_cone_chart.cone3_100.both["Typhoon"],
        },
      ];
      let max = this.state.single_asset_cone_chart.scenario_max;

      let yearConfig = {
        data: yearData,
        color: ["#f47a7b", "#8CB0F8", "#18202F", "#256EFF"],
        yAxis: {
          max: max + 0.2 * max,
        },
        legend: false,
        isGroup: true,
        xField: "variable",
        colorField: "name",

        yField: "index",
        seriesField: "name",

        label: {
          position: "top",
        },
      };
      this.setState({ YearData: yearConfig });
    }

    this.setState(
      {
        RcpData: RcpConfig,
      },
      () => console.log("yeardata", this.state.yearData)
    );
    if (this.state.single_asset_hazard.both) {
      let ad_var = [
        "Rainfall Flood",
        "Extreme Heat",
        "River Flood",
        "Typhoon",
        "Storm Surge",
        "Landslide",
        "Drought",
        "Sea Level Rise",
        "Snow Fall",
        "Wild Fire",
      ];
      for (ad_var in this.state.single_asset_hazard.both) {
        if (this.state.single_asset_hazard.both[ad_var][2] > 50) {
          let value = this.state.single_asset_hazard.both[ad_var][2];

          adaptation_data.push({
            priority: value,
            description: ad_var,
          });
          console.log("adapt", adaptation_data);
        }
      }
    }
  };
  handleChange = (value, key) => {
    this.setState({
      [key]: value,
    });
  };
  handleChangePro = (value, key) => {
    this.setState(
      {
        [key]: value,
      },
      () => console.log("analysis", this.state.analysis)
    );
  };
  handleTable = (value, key) => {
    this.setState({
      [key]: value,
    });
  };
  handleExposure = (value, key) => {
    this.setState(
      {
        [key]: value,
      },
      this.handleSubmitPro
    );
  };
  handleSingleExposure = (value, key) => {
    this.setState(
      {
        [key]: value,
      },
      this.handleSubmitPro
    );
  };

  handleFullScreen = () => {
    document.getElementById("HeatMap").requestFullscreen();
  };
  handleLossFullScreen = () => {
    document.getElementById("Loss").requestFullscreen();
  };
  handleIntFullScreen = () => {
    document.getElementById("Intensity").requestFullscreen();
  };

  handleClickOpen = (e, tabProps) => {
    const { index } = tabProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  handleSubmitPro = () => {
    if (this.state.analysis == "rcp") {
      let formdata = new FormData();

      if (this.state.year == 2100) {
        this.state.year = 2050;

        formdata.append("project_name", this.state.project);
        formdata.append("scenario", this.state.rcp);
        formdata.append("variable", this.state.exposure_variable);
        formdata.append("year", this.state.year);
        formdata.append("currency", this.state.currency);
        //formdata.append("use_valuation", this.state.use_valuation);
        //formdata.append("currency", this.state.currency);
        formdata.append("percentage_type", this.state.use_valuation);
        formdata.append("mitigation", this.state.mitigation);
        formdata.append("count", this.state.count);
        formdata.append("analysis_type", this.state.analysis);
        formdata.append("parameter", this.state.parameter);
        formdata.append("with_content", this.state.with_content);
        formdata.append("adjusted_gdp", this.state.adjusted_gdp);
        formdata.append("property_type", this.state.property_type);
      } else {
        formdata.append("project_name", this.state.project);
        formdata.append("scenario", this.state.rcp);
        formdata.append("variable", this.state.exposure_variable);
        // formdata.append("currency", this.state.currency);
        formdata.append("year", this.state.year);
        // formdata.append("use_valuation", this.state.use_valuation);
        formdata.append("percentage_type", this.state.use_valuation);
        formdata.append("mitigation", this.state.mitigation);
        formdata.append("count", this.state.count);
        formdata.append("analysis_type", this.state.analysis);
        formdata.append("adjusted_gdp", this.state.adjusted_gdp);
        formdata.append("parameter", this.state.parameter);
        formdata.append("with_content", this.state.with_content);
        formdata.append("property_type", this.state.property_type);
      }

      let project = this.props.project.data.filter(
        (project) => project.name == this.state.project
      );
      console.log("project_submit", project[0].variables);

      this.props.addDashboard(formdata);

      this.setState({
        filterOpen: false,
        Million: true,

        variables: project[0].variables,
      });
    } else if (this.state.analysis == "ssp") {
      let formdata = new FormData();
      formdata.append("project_name", this.state.project);
      formdata.append("scenario", this.state.ssp);
      formdata.append("percentage_type", this.state.use_valuation);
      formdata.append("variable", this.state.exposure_variable);
      formdata.append("year", this.state.year);
      formdata.append("currency", this.state.currency);
      formdata.append("mitigation", this.state.mitigation);
      formdata.append("count", this.state.count);
      formdata.append("analysis_type", this.state.analysis);
      formdata.append("parameter", this.state.parameter);
      formdata.append("adjusted_gdp", this.state.adjusted_gdp);
      formdata.append("with_content", this.state.with_content);
      formdata.append("property_type", this.state.property_type);
      this.props.addDashboard(formdata);
      this.setState({
        filterOpen: false,
      });
    }
  };

  handleLocal = (e) => {
    this.setState(
      {
        localactive: true,
        globalactive: false,
      },
      this.handleSubmitPro
    );
  };

  handleGlobal = (e) => {
    this.setState(
      {
        globalactive: true,
        localactive: false,
      },
      this.handleSubmitPro
    );
  };
  handleFinance = (e) => {
    this.setState({
      financial: !this.state.financial,
    });
  };

  handleSsp = (e) => {
    this.setState({
      ssp: !this.state.ssp,
    });
  };

  handleWorld = (e) => {
    this.setState((prevState) => ({
      worldmap: !prevState.worldmap,
    }));
  };
  handleDetail = (e) => {
    this.setState((prevState) => ({
      detailed: !prevState.detailed,
    }));
  };
  handleContent = (e) => {
    localStorage.setItem("with_content", !this.state.with_content);
    this.setState({
      with_content: !this.state.with_content,
    });
  };
  handleAsset = (e, { value }) => {
    let selectedAsset = this.state.asset_table.filter(
      (asset) => asset.name == value
    );
    console.log("selectedAsset", selectedAsset[0].latitude);
    this.setState(
      {
        lat: selectedAsset[0].latitude,
        long: selectedAsset[0].longitude,
      },
      () => console.log("lat passing", this.state.lat, this.state.long)
    );
  };
  handleHazard = (e, { value }) => {
    this.setState(
      {
        hazard_map: value,
      },
      () => console.log("hazard", this.state.hazard_map)
    );
  };
  handleMitigation = (e, { value }) => {
    this.setState({
      mitigation_variable: value,
    });
  };
  handleMitigationMeasure = (e, { value }) => {
    this.setState({
      metigation_measure: value,
    });
  };

  useValuation = (e) => {
    this.setState(
      { use_valuation: !this.state.use_valuation },
      this.handleSubmitPro
    );
  };

  handleContinent = (e, { value }) => {
    console.log("Continents", value);
    this.setState({
      continent: value,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ active: !prevState.active }));
  };

  handleAccClick = (e, tabProps) => {
    const { index } = tabProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex }, () =>
      console.log("active", this.state.activeIndex)
    );
  };
  componentWillUnmount() {
    if (this.view) {
      this.view.destroy();
    }
  }

  render() {
    console.log("card data", this.state.climate_risk_card_data);
    let newVar = localStorage.getItem("variables") === this.state.variables;
    const isDarkMode = localStorage.getItem("theme") == "dark";
    let Var = this.state.variables;
    let Property = this.state.property_types;

    if (this.state.hazard_continent) {
      for (let i = 0; i < this.state.hazard_continent.length; i++) {
        ContinentOptions.push({
          key: this.state.hazard_continent[i],
          value: this.state.hazard_continent[i],
          text: this.state.hazard_continent[i],
        });
      }
    }
    console.log("subs", this.state.subscription);
    if (this.state.variables) {
      HazardOptions = [];

      for (let i = 0; i < this.state.variables.length; i++) {
        HazardOptions.push({
          key: this.state.variables[i],
          text: this.state.variables[i],
          value: this.state.variables[i],
        });
      }
    }

    if (Property != "NA") {
      console.log("Property value", this.state.property_types);
      PropertyOptions = [];
      for (let i = 0; i < Property.length; i++) {
        PropertyOptions.push({
          key: Property[i],
          value: Property[i],
          text: Property[i],
        });
      }
      ParameterOptions = [];
      ParameterOptions.push(
        { key: "valuation", value: "valuation", text: "valuation" },
        { key: "loss", value: "loss", text: "Overall Loss" },
        {
          key: "revenue",
          value: "revenue",
          text: "revenue",
        }
      );
    }
    if (this.state.asset_table) {
      AssetOptions = [];
      for (let i = 0; i < this.state.asset_table.length; i++) {
        AssetOptions.push({
          key: this.state.asset_table[i].name,
          value: this.state.asset_table[i].name,
          text: this.state.asset_table[i].name.slice(0, 10),
        });
      }
    }
    const {
      hazard,
      hazard_without_adaptation,
      risk_2020,
      risk_2020_without_adaptation,
      single_asset_hazard,
      single_asset_hazard_without_adaptation,
      single_asset_hazard_2020,
      single_asset_hazard_2020_without_adaptation,
      heatmap,
      heatmap_without_adaptation,
    } = this.state;

    const activeRiskData = this.state.adaptationIntensity
      ? hazard
      : hazard_without_adaptation;

    const activeRiskData_2020 = this.state.adaptationIntensity
      ? risk_2020
      : risk_2020_without_adaptation;

    const singleactiveRiskData = this.state.adaptationIntensity
      ? single_asset_hazard
      : single_asset_hazard_without_adaptation;

    const singleactiveRiskData_2020 = this.state.adaptationIntensity
      ? single_asset_hazard_2020
      : single_asset_hazard_2020_without_adaptation;

    const activeHeatmapData = this.state.adaptationHeatmap
      ? heatmap
      : heatmap_without_adaptation;

    const {
      continent,
      value,
      basement,
      construction,
      stories,
      occupancy,
      project,
      rcp,
      year,
      active,
      table,
      count,
      parameter,
      exposure_variable,
      property_type,
      ssp,
      analysis,
      hoveredAsset,
    } = this.state;

    let total_asset_value = 0;

    const { activeIndex } = this.state;

    if (this.props.project.data) {
      console.log("project", this.props.project.data);
      const projects = this.props.project.data;

      options = [];
      for (let i = 0; i < projects.length; i++) {
        options.push({
          key: projects[i].name,
          value: projects[i].name,
          text: projects[i].name.slice(10),
        });
      }
    }

    if (this.props.isLoading) {
      return <div id="loading"> </div>;
    }

    return (
      <div>
        <br />
        <Icon
          name="info"
          onClick={this.FilterInfo}
          style={{ cursor: "pointer", float: "right", marginRight: "2.75%" }}
        />{" "}
        <StickyClimateFilterHeader
          data={this.state}
          analysis={this.state.analysis}
          rcp={this.state.rcp}
          ssp={this.state.ssp}
          year={this.state.year}
          with_content={this.state.with_content}
          financial={this.state.financial}
          adjusted_gdp={this.state.adjusted_gdp}
          handleChangePro={this.handleChangePro}
          handleSubmitPro={this.handleSubmitPro}
          AnalysisOptions={AnalysisOptions}
          RcpOptions={RcpOptions}
          YearOptions={YearOptions}
          YearOptions_ssp={YearOptions_ssp}
          ContentOptions={ContentOptions}
          FinanceOptions={FinanceOptions}
          GdpOptions={GdpOptions}
        />
        <Container fluid={true} style={{ marginTop: "2rem" }}>
          {/* ===================== Risk Map ===================== */}
          <div id="risk-map-section" style={sectionContainerStyle}>
            <Row className="mainheading" style={{ alignItems: "center" }}>
              <Col lg={8}>
                <p
                  style={{
                    marginBottom: "8px",
                    fontSize: "1.2rem",
                    fontWeight: 500,
                  }}
                >
                  Risk Map
                </p>
              </Col>
              <Col lg={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Select
                    placeholder="Hazard"
                    style={{ width: "180px" }}
                    value={this.state.hazard_map}
                    onChange={this.handleHazard}
                  >
                    {HazardOptions.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.text}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
            </Row>

            <Container style={{ width: "100%" }} fluid>
              {this.state.subscription.overall_dashboard
                ?.asset_level_risk_map &&
              this.state.combined_data &&
              [
                "Rainfall Flood",
                "Extreme Heat",
                "River Flood",
                "Landslide",
                "Typhoon",
                "Drought",
                "Snow Fall",
                "Sea Level Rise",
                "Storm Surge",
                "Wild Fire",
                "Extreme Cold",
              ].includes(this.state.hazard_map) ? (
                <ClusterMap
                  hazard={this.state.hazard_map}
                  data={this.state.combined_data}
                  subscription={this.state.subscription}
                />
              ) : (
                <Tier />
              )}
            </Container>
          </div>

          {/* ===================== Climate Variable Intensity ===================== */}
          <div id="climate-intensity-section" style={sectionContainerStyle}>
            <Row className="mainheading" style={{ alignItems: "center" }}>
              <Col lg={8}>
                <p>
                  <span className="dark-mode-theme-color-1">
                    Climate Variable Intensity
                  </span>
                </p>
              </Col>
              <Col lg={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() =>
                      downloadSectionAsImage(
                        "climate-intensity-section",
                        "Climate_Intensity"
                      )
                    }
                  >
                    Download
                  </Button>
                  <span style={{ fontSize: "0.85rem" }}>Adaptation:</span>
                  <Switch
                    checked={this.state.adaptationIntensity}
                    onChange={this.handleAdaptationToggleIntensity}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                  />
                </div>
              </Col>
            </Row>

            {this.state.subscription.overall_dashboard
              ?.climate_variable_intensity ? (
              <Col lg={12}>
                {activeRiskData && this.state.hazard && (
                  <Progress_bar
                    newdata={activeRiskData_2020}
                    hazard={activeRiskData}
                    variable={this.state.variables}
                    analysis={this.state.analysis}
                    activeIndex={this.state.activeIndex}
                    year={this.state.year}
                  />
                )}
                <Row className="mainheading">
                  <p>
                    <Button
                      style={{
                        color: "#18202F",
                        backgroundColor: "#fff",
                        borderColor: "#18202F",
                        border: "1px solid",
                        float: "right",
                      }}
                      variant="info"
                      onClick={this.handleKeyFindings_2}
                    >
                      Key Findings
                    </Button>
                  </p>
                </Row>
              </Col>
            ) : (
              <Tier />
            )}
          </div>

          {/* ===================== Hazard Heatmap ===================== */}
          <div id="heatmap-section" style={sectionContainerStyle}>
            <Row className="mainheading" style={{ alignItems: "center" }}>
              <Col lg={8}>
                <p>
                  <span className="dark-mode-theme-color-1">
                    Hazard Heat Map
                  </span>
                </p>
              </Col>
              <Col lg={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() =>
                      downloadSectionAsImage(
                        "heatmap-section",
                        "Hazard_Heatmap"
                      )
                    }
                  >
                    Download
                  </Button>
                  <span style={{ fontSize: "0.85rem" }}>Adaptation:</span>
                  <Switch
                    checked={this.state.adaptationHeatmap}
                    onChange={this.handleAdaptationToggleHeatmap}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                  />
                </div>
              </Col>
            </Row>

            {this.state.subscription.overall_dashboard?.climate_heatmap ? (
              <Col lg={12}>
                {activeHeatmapData && (
                  <Classicheatmap
                    data={activeHeatmapData}
                    variable={this.state.variables}
                    analysis={this.state.analysis}
                  />
                )}
              </Col>
            ) : (
              <Tier />
            )}
          </div>

          {/* <div id="heatmap-section-bi" style={sectionContainerStyle}>
            <Row className="mainheading" style={{ alignItems: "center" }}>
              <Col lg={8}>
                <p>
                  <span className="dark-mode-theme-color-1">
                    Hazard Heat Map (BI days)
                  </span>
                </p>
              </Col>
              <Col lg={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() =>
                      downloadSectionAsImage(
                        "heatmap-section-bi",
                        "Hazard_Heatmap"
                      )
                    }
                  >
                    Download
                  </Button>
                  <span style={{ fontSize: "0.85rem" }}>Adaptation:</span>
                  <Switch
                    checked={this.state.adaptationHeatmap}
                    onChange={this.handleAdaptationToggleHeatmap}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                  />
                </div>
              </Col>
            </Row>

            {this.state.subscription.overall_dashboard?.climate_heatmap ? (
              <Col lg={12}>
                {activeHeatmapData && (
                  <Classicheatmap
                    data={this.state.heatmap_bi}
                    variable={this.state.variables}
                    analysis={this.state.analysis}
                  />
                )}
              </Col>
            ) : (
              <Tier />
            )}
          </div>*/}

          {/* ===================== Financial View ===================== */}
          <div id="financial-section" style={sectionContainerStyle}>
            <Row className="mainheading" style={{ alignItems: "center" }}>
              <Col lg={8}>
                <p>
                  <span className="dark-mode-theme-color-1">
                    Financial View
                  </span>
                </p>
              </Col>
              <Col lg={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() =>
                      downloadSectionAsImage(
                        "financial-section",
                        "Financial_View"
                      )
                    }
                  >
                    Download
                  </Button>
                </div>
              </Col>
            </Row>

            <Col lg={12}>
              <ClimateRiskKPICards
                data={{
                  climate_risk_card_data: this.state.climate_risk_card_data,
                }}
                handleCardFindings_1={this.handleCardFindings_1}
                handleCardFindings_3={this.handleCardFindings_3}
                handleCardFindings_5={this.handleCardFindings_5}
                handleCardFindings_6={this.handleCardFindings_6}
              />

              {this.state.subscription.overall_dashboard?.portfolio_losses &&
              this.state.losses["detailed"] ? (
                <>
                  {this.state.financial ? (
                    <LossComponent
                      data={this.state.losses}
                      year={this.state.year}
                      newdata={this.state.losses_2020}
                      inventory={this.state.inventory}
                      inventory_2020={this.state.inventory_2020}
                    />
                  ) : (
                    <LossPercentComponent
                      year={this.state.year}
                      data={this.state.losses}
                      newdata={this.state.losses_2020}
                      inventory={this.state.inventory}
                      inventory_2020={this.state.inventory_2020}
                    />
                  )}

                  <Row style={{ marginTop: "1rem" }}>
                    {this.state.subscription.overall_dashboard
                      ?.rcp_year_loss_bars ? (
                      <Col
                        lg={12}
                        xs={12}
                        sm={12}
                        style={{ maxWidth: "95.6%" }}
                      >
                        <Row className="g-4">
                          <Col lg={6} xs={12}>
                            <div className="bg-white p-3 rounded shadow-sm h-100">
                              <h6 className="fw-bold mb-3">
                                Year Loss for{" "}
                                {this.state.analysis.toUpperCase()}{" "}
                                {this.state.analysis === "rcp" ? (
                                  <span>{this.state.rcp}</span>
                                ) : (
                                  <span>{this.state.ssp}</span>
                                )}
                              </h6>
                              <YEARDonut
                                data={this.state.yearDetail}
                                rcp={this.state.rcp}
                                ssp={this.state.ssp}
                                year={this.state.year}
                                key_find={this.state.key_finding_data}
                                analysis={this.state.analysis}
                                unitType={
                                  this.state.financial ? "dollar" : "percentage"
                                }
                              />
                            </div>
                          </Col>

                          <Col lg={6} xs={12}>
                            <div className="bg-white p-3 rounded shadow-sm h-100">
                              <h6 className="fw-bold mb-3">
                                {this.state.analysis.toUpperCase()} Loss for
                                Year {this.state.year}
                              </h6>
                              <RCPDonut
                                data={this.state.yearDetail}
                                year={this.state.year}
                                key_find={this.state.key_finding_data}
                                analysis={this.state.analysis}
                                unitType={
                                  this.state.financial ? "dollar" : "percentage"
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      <Col lg={12}>
                        <Tier />
                      </Col>
                    )}
                  </Row>

                  <Row className="mainheading" style={{ marginTop: "1rem" }}>
                    <p>
                      <Button
                        style={{
                          color: "#18202F",
                          backgroundColor: "#fff",
                          borderColor: "#18202F",
                          border: "1px solid",
                          float: "right",
                        }}
                        variant="info"
                        onClick={this.handleKeyFindings_3}
                      >
                        Key Findings
                      </Button>
                    </p>
                  </Row>
                </>
              ) : (
                <Tier />
              )}
            </Col>
          </div>

          {/* ===================== Asset Table ===================== */}
          <div id="asset-table-section" style={sectionContainerStyle}>
            <Row className="mainheading" style={{ alignItems: "center" }}>
              <Col lg={8}>
                <p>
                  <span className="dark-mode-theme-color-1">Asset Table</span>
                </p>
              </Col>
              <Col lg={4}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                  }}
                >
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() =>
                      downloadSectionAsImage(
                        "asset-table-section",
                        "Asset_Table"
                      )
                    }
                  >
                    Download
                  </Button>
                </div>
              </Col>
            </Row>

            <Row>
              {this.state.subscription.overall_dashboard?.asset_table ? (
                <Col lg={12} style={{ overflowX: "auto", padding: 0 }}>
                  {this.state.table_condition && !this.state.loading ? (
                    <EditableTable
                      data={this.state.asset_table}
                      open={this.handleOpen}
                      permission={this.state.edit_permission}
                      update={this.Edit}
                      info={this.MitigationInfo}
                    />
                  ) : (
                    <Spinner />
                  )}
                </Col>
              ) : (
                <Tier />
              )}
            </Row>
          </div>
        </Container>
        ;
        <Modal
          open={this.state.modalOpen}
          onClose={this.handleClose}
          closeIcon
          className="individual"
          itemName={this.state.activeItemName}
          size="fullscreen"
          style={{ zIndex: "3000" }}
        >
          <Modal.Header
            style={isDarkMode ? { backgroundColor: "#001244" } : {}}
          >
            Asset Analysis - {this.state.activeItemName}
          </Modal.Header>

          <Modal.Content
            style={isDarkMode ? { backgroundColor: "#001244" } : {}}
          >
            <br />
            <Row>
              <Col>
                <Tabs defaultActiveKey="Risk">
                  <TabPane key="Risk" tab="Risk">
                    <br />

                    <Container fluid={true}>
                      {/* TOP SUMMARY ROW */}
                      <Row className="align-items-center justify-content-between">
                        <Col lg={8} style={{ fontSize: "0.9rem" }}>
                          <p
                            style={{
                              marginBottom: "0px",
                              fontSize: "1.2rem",
                              fontWeight: 500,
                            }}
                          >
                            Physical Climate Risk Assessment &nbsp;|&nbsp;
                            {this.state.analysis ? (
                              <span
                                style={{ fontSize: "1.2rem", fontWeight: 200 }}
                              >
                                {this.state.variables.length} Hazards ·{" "}
                                {this.state.analysis.toUpperCase()}{" "}
                                {this.state.rcp} · Year {this.state.year}
                              </span>
                            ) : null}
                          </p>
                        </Col>

                        <Col
                          lg={4}
                          className="d-flex align-items-center justify-content-end"
                          style={{ gap: "12px" }}
                        >
                          <span style={{ fontSize: "1.2rem", fontWeight: 500 }}>
                            Climate Score:
                          </span>
                          <span style={{ fontSize: "1.2rem", fontWeight: 200 }}>
                            {this.state.single_asset_climate_score}%
                          </span>

                          <span
                            style={{
                              padding: "2px 8px",
                              borderRadius: "12px",
                              background:
                                this.state.single_asset_climate_score < 20
                                  ? "#4CAF50"
                                  : this.state.single_asset_climate_score < 60
                                  ? "#FFC107"
                                  : "#F44336",
                              color: "white",
                              fontSize: "1.2rem",
                              textTransform: "capitalize",
                            }}
                          >
                            {this.state.single_asset_climate_score < 20
                              ? "low risk"
                              : this.state.single_asset_climate_score < 60
                              ? "medium risk"
                              : "high risk"}
                          </span>
                        </Col>
                      </Row>

                      {/* PROGRESS BAR */}
                      <Row>
                        <Col>
                          <Progress
                            percent={this.state.single_asset_climate_score}
                            size="small"
                            showInfo={false}
                            style={{ marginBottom: "0.5%", padding: "0.5%" }}
                          />
                        </Col>
                      </Row>

                      <br />

                      {/* ASSET MAP LOCATION */}
                      <Row className="border rounded mb-4">
                        <Col lg={12} sm={16} xs={16}>
                          <Row className="shared-heading">
                            <p>
                              <span className={"dark-mode-theme-color-1"}>
                                Asset Map
                              </span>
                            </p>
                          </Row>
                          {this.state.mapAsset ? (
                            <PopupMap data={this.state.mapAsset} />
                          ) : null}
                        </Col>
                      </Row>

                      {/* CLIMATE VARIABLE INTENSITY */}
                      <Row className="border rounded mb-4">
                        <Col
                          md={12}
                          sm={16}
                          xs={16}
                          className="card"
                          style={{ padding: "0" }}
                        >
                          <Row className="mainheading shared-heading">
                            <Col lg={8} style={{ paddingLeft: "0" }}>
                              <p>
                                <span className="dark-mode-theme-color-1">
                                  Climate Variable Intensity
                                </span>
                              </p>
                            </Col>

                            <Col lg={4}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  float: "right",
                                }}
                              >
                                <span style={{ fontSize: "0.85rem" }}>
                                  Adaptation:
                                </span>
                                <Switch
                                  checked={this.state.adaptationIntensity}
                                  onChange={
                                    this.handleAdaptationToggleIntensity
                                  }
                                  checkedChildren="On"
                                  unCheckedChildren="Off"
                                />
                              </div>
                            </Col>
                          </Row>

                          <Col lg={12}>
                            {singleactiveRiskData &&
                            singleactiveRiskData_2020 ? (
                              <Progress_bar
                                hazard={singleactiveRiskData}
                                newdata={singleactiveRiskData_2020}
                                analysis={this.state.analysis}
                                data={this.state.single_asset_progress}
                                variable={this.state.variables}
                                year={this.state.year}
                              />
                            ) : null}
                          </Col>
                        </Col>
                      </Row>

                      {/* FINANCIAL VIEW */}
                      <Row className="border rounded mb-4">
                        <Col lg={12}>
                          <Row className="mainheading shared-heading">
                            <p>
                              <span className="dark-mode-theme-color-1">
                                Financial View
                              </span>
                            </p>
                          </Row>
                        </Col>

                        {this.state.single_asset_loss["detailed"] ? (
                          <Col
                            lg={12}
                            xs={16}
                            sm={16}
                            className="card"
                            style={{ marginTop: "-1.5%" }}
                          >
                            {this.state.single_asset_overall ? (
                              <ClimateRiskKPICards
                                data={{
                                  climate_risk_card_data: this.state
                                    .single_climate_risk_card_data,
                                }}
                                handleCardFindings_1={this.handleCardFindings_1}
                                handleCardFindings_3={this.handleCardFindings_3}
                                handleCardFindings_5={this.handleCardFindings_5}
                                handleCardFindings_6={this.handleCardFindings_6}
                              />
                            ) : null}

                            <Row>
                              <Col>
                                {this.state.losses["detailed"] ? (
                                  <div>
                                    {this.state.financial ? (
                                      <LossComponent
                                        data={this.state.single_asset_loss}
                                        year={this.state.year}
                                        newdata={
                                          this.state.single_asset_loss_2020
                                        }
                                        inventory={
                                          this.state.single_asset_inventory
                                        }
                                        inventory_2020={
                                          this.state.single_asset_inventory_2020
                                        }
                                      />
                                    ) : (
                                      <LossPercentComponent
                                        year={this.state.year}
                                        data={this.state.single_asset_loss}
                                        newdata={
                                          this.state.single_asset_loss_2020
                                        }
                                        inventory={
                                          this.state.single_asset_inventory
                                        }
                                        inventory_2020={
                                          this.state.single_asset_inventory_2020
                                        }
                                      />
                                    )}
                                  </div>
                                ) : null}
                              </Col>
                            </Row>
                          </Col>
                        ) : null}
                      </Row>

                      {/* YEAR LOSS + RCP LOSS */}
                      <Row className="border rounded mb-4">
                        {this.state.singleYearDetail ? (
                          <Col xs={16} sm={16} lg={6}>
                            <Row className="shared-heading">
                              <p>
                                <span className={"dark-mode-theme-color-1"}>
                                  Year Loss for{" "}
                                  {this.state.analysis.toUpperCase()}{" "}
                                  {this.state.analysis == "rcp" ? (
                                    <span>{this.state.rcp}</span>
                                  ) : (
                                    <span>{this.state.ssp}</span>
                                  )}
                                </span>
                              </p>
                            </Row>

                            <YEARDonut
                              data={this.state.singleYearDetail}
                              rcp={this.state.rcp}
                              ssp={this.state.ssp}
                              year={this.state.year}
                              analysis={this.state.analysis}
                              unitType={
                                this.state.financial ? "dollar" : "percentage"
                              }
                            />
                          </Col>
                        ) : null}

                        <Col xs={16} sm={16} lg={6}>
                          <Row className="shared-heading">
                            <p>
                              <span className={"dark-mode-theme-color-1"}>
                                {this.state.analysis.toUpperCase()} Loss for
                                Year {this.state.year}
                              </span>
                            </p>
                          </Row>

                          <RCPDonut
                            data={this.state.singleYearDetail}
                            year={this.state.year}
                            analysis={this.state.analysis}
                            unitType={
                              this.state.financial ? "dollar" : "percentage"
                            }
                          />
                        </Col>
                      </Row>
                    </Container>
                  </TabPane>

                  {/* COMPARISON TAB */}
                  <TabPane key="Comparison" tab="Comparison">
                    <br />
                    <Container fluid={true}>
                      <Row>
                        {/* RCP Comparison */}
                        <Col
                          lg={12}
                          xs={16}
                          sm={16}
                          className="card dark-mode-black"
                        >
                          <Row className="shared-heading">
                            <p>
                              <span className={"dark-mode-theme-color-1"}>
                                {this.state.analysis.toUpperCase()} 2.6 vs{" "}
                                {this.state.analysis.toUpperCase()} 4.5 vs{" "}
                                {this.state.analysis.toUpperCase()} 8.5 for Year
                                2050
                              </span>
                            </p>
                          </Row>

                          {this.state.RcpData && this.state.RcpData.data ? (
                            <Column {...this.state.RcpData} />
                          ) : null}
                        </Col>

                        {/* YEAR Comparison */}
                        <Col
                          lg={12}
                          xs={16}
                          sm={16}
                          className="card dark-mode-black"
                        >
                          <Row className="shared-heading">
                            {this.state.analysis == "rcp" ? (
                              <p>
                                <span className={"dark-mode-theme-color-1"}>
                                  Year 2020 vs Year 2030 vs Year 2050 for{" "}
                                  {this.state.analysis.toUpperCase()}{" "}
                                  {this.state.rcp}
                                </span>
                              </p>
                            ) : (
                              <p>
                                <span className={"dark-mode-theme-color-1"}>
                                  Year 2020 vs Year 2030 vs Year 2050 vs Year
                                  2100 for {this.state.analysis.toUpperCase()}{" "}
                                  {this.state.ssp}
                                </span>
                              </p>
                            )}
                          </Row>

                          {this.state.YearData && this.state.YearData.data ? (
                            <Column {...this.state.YearData} />
                          ) : null}
                        </Col>

                        <Col width="1"></Col>
                      </Row>
                    </Container>
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          </Modal.Content>
        </Modal>
        <Modal
          open={this.state.mitigation_info}
          closeIcon
          onClose={this.MitigationClose}
        >
          <Modal.Header>Flood Risk Reduction Level</Modal.Header>
          <Modal.Content>
            <div>
              <p>
                <b>
                  Please select appropriate flood risk reduction level from High
                  to Low on the pull-down manual by referring to the below
                  guidance.{" "}
                </b>
                <br />
                This function is to account for the flood risk reduction
                capacity of three flood mitigation measures that are near the
                asset and connect to the main flood control / stormwater
                management system of the area: a) manhole, b) catchpit, and c)
                underground flood tunnel. These mitigation measures are
                effective to reduce rainfall and river flooding, and they
                include any existing or to-be-built measures. It does not apply
                to storm surge flooding, as when there is a rise in sea level on
                the coastal side, the floodwater is very likely to block most
                nearby outlets of the stormwater management system.
                <br />
                <br /> The level of flood risk reduction depends on below two
                key factors and assumption: <br />
                1. Distance between any mitigation measure and the asset. To
                have a risk reduction impact, the closer the mitigation measure
                to the asset, the greater level of risk reduction. Any
                mitigation measure that is more than 20 meters far from the
                asset is assumed to have no risk reduction effect.
                <br /> 2. The number of available mitigation measures. The more
                the number of mitigation measures, the greater level of risk
                reduction. It can be in any combination of item a, b, and c as
                listed above, e.g., asset with two nearby manholes plus one
                nearby underground flood tunnel is counted as a total of 3
                measures for that asset.
                <br /> <br />
                A. <b>High level</b> of flood risk reduction – Either:
                <br /> i. Having at least <u>three measures</u> in place near
                the asset. Two measures both are at least within a distance of ≤
                10 meters, plus the remaining measure is at least within 15-20
                meters; or <br />
                ii. Having at least <u>three measures </u>in place near the
                asset. Two measures both are at least within a distance of 10-15
                meters, plus the remaining measure is at least within ≤ 10
                meters.
                <br /> <br />
                B. <b>Median level</b> of flood risk reduction – Either:
                <br /> i. Having at least <u>three measures</u> in place. Two
                measure both are at least within 15-20 meters, plus the
                remaining measure is at least within 10-15 meters; or
                <br /> ii. Having at least <u>two measures</u> in place near the
                asset. One measure is at least within ≤ 10 meters, plus another
                one is at least within 15-20 meters; or
                <br /> iii. Having at least <u>two measures</u> in place near
                the asset, and two measures both are at least within 10-15
                meters.
                <br />
                <br />
                C. <b>Low level</b> of flood risk reduction – Either: <br />
                i. Having at least <u>two measures </u>in place, and these two
                measures both are at least within 15-20 meters; or <br />
                ii. Having at least <u>one measure</u> in place, and this
                measure is at least within a distance of ≤ 10 meters.
                <br />
                <br /> Example: An asset has nearby two flood mitigation
                measures (no matter what combination of a) manhole, b) catchpit
                or c) underground flood tunnel). One measure (e.g., manhole) is
                within 10-15 meters and another measure (e.g., catchpit or
                another manhole) is at 15-20 meters far from the asset. Both
                measures are connected to the city-level stormwater management
                system. In this example, as it can’t fulfill the requirement of
                the median level of flood risk reduction of points B) ii and B)
                iii above, it falls into the category of low level of flood risk
                reduction.
              </p>
            </div>
          </Modal.Content>
        </Modal>
        <Modal open={this.state.Cvar} closeIcon onClose={this.CvarClose}>
          <Modal.Header>Climate Value at Risk</Modal.Header>
          <Modal.Content>
            <p>
              Climate value at risk (CVaR) is a measure for estimating the
              maximum amount of loss over a one year period due to co-occurring
              extreme events. CVaR can be thought of as a potential loss due to
              the exposure of an asset, displayed as a $ value or a percentage
              (%).
            </p>
          </Modal.Content>
        </Modal>
        <Modal
          open={this.state.FilterInfo}
          closeIcon
          onClose={this.FilterInfoClose}
        >
          <Modal.Header>Advance Filter</Modal.Header>
          <Modal.Content>
            <p>
              Make use of the “Advance Filter” to view detailed analysis results
              of the same project under different variables (e.g., scenario and
              year), toggle to view the Climate Value at Risk in $ loss or as a
              percentage (%).
              <br />
              Simply select the desired variable/criteria, and press “Apply
              Filter”.
            </p>
          </Modal.Content>
        </Modal>
        <Modal open={this.state.lossopen} closeIcon onClose={this.lossClose}>
          <Modal.Content>
            <Col
              id="Intensity"
              lg={12}
              xs={12}
              sm={12}
              style={{ padding: "5%" }}
            >
              <Row className="mainheading">
                <p>
                  <span className={"dark-mode-theme-color-1"}>
                    Climate Variable Intensity
                  </span>
                </p>
              </Row>
              <Row>
                <Col></Col>
              </Row>
              <br />

              {this.state.hazard && this.state.risk_2020 ? (
                <Progress_bar
                  hazard={this.state.hazard}
                  newdata={this.state.risk_2020}
                  variable={this.state.variables}
                  activeIndex={this.state.activeIndex}
                />
              ) : null}
            </Col>
          </Modal.Content>
        </Modal>
        <Modal
          open={this.state.percentopen}
          closeIcon
          onClose={this.percentClose}
        >
          <Modal.Content>
            <Col id="Loss" lg={12} sm={12} xs={12}>
              <Row className="mainheading">
                {" "}
                <p>
                  <span className={"dark-mode-theme-color-1"}>
                    Portfolio Losses
                  </span>
                </p>
              </Row>

              {this.state.losses["detailed"] ? (
                <div>
                  {" "}
                  {this.state.financial ? (
                    <LossComponent
                      data={this.state.losses}
                      year={this.state.year}
                      newdata={this.state.losses_2020}
                      inventory={this.state.inventory}
                      inventory_2020={this.state.inventory_2020}
                    />
                  ) : (
                    <LossPercentComponent
                      data={this.state.losses}
                      year={this.state.year}
                      newdata={this.state.losses_2020}
                      inventory={this.state.inventory}
                      inventory_2020={this.state.inventory_2020}
                    />
                  )}
                </div>
              ) : null}
            </Col>
          </Modal.Content>
        </Modal>
        <Modal open={this.state.heatopen} closeIcon onClose={this.heatClose}>
          <Modal.Content>
            <Col className="firstshadow" lg={12} xs={16} sm={16}>
              <Row className="mainheading">
                <p>
                  <span className={"dark-mode-theme-color-1"}>
                    Climate Risk Heat Map (0 to 100){" "}
                  </span>
                </p>
              </Row>
              <Row>
                <Col>
                  {this.state.heatmap ? (
                    <Classicheatmap
                      data={this.state.heatmap}
                      variable={this.state.variables}
                      analysis={this.state.analysis}
                    />
                  ) : null}
                </Col>
              </Row>
            </Col>
          </Modal.Content>
        </Modal>
        <Modal open={this.state.riskOpen} closeIcon onClose={this.RiskClose}>
          <Modal.Header>Climate Risk Index</Modal.Header>
          <Modal.Content>
            <Image src={index} />
          </Modal.Content>
        </Modal>
        <Modal
          open={this.state.filterOpen}
          closeIcon
          onClose={this.filterClose}
        >
          <Modal.Header className="advance">
            <h2>Advanced Filter Options</h2>
            <p>Filtering your data for more insight</p>
          </Modal.Header>
          <Modal.Content className="Filter">
            <Row>
              <Col lg={4} style={{ wordBreak: "break-word" }}>
                <p>Projects</p>
                <Form.Select
                  placeholder="Project"
                  onChange={(e, { value }) =>
                    this.handleChangePro(value, "project")
                  }
                  value={project}
                  options={options}
                  disabled={this.state.detailed}
                />
              </Col>

              <Col lg={4}>
                <p>Analysis Type</p>
                <Form.Select
                  placeholder="Analysis Type"
                  onChange={(e, { value }) =>
                    this.handleChangePro(value, "analysis")
                  }
                  value={analysis}
                  options={AnalysisOptions}
                />
              </Col>

              <Col lg={4}>
                {this.state.analysis == "rcp" ? (
                  <>
                    {" "}
                    <p>RCP</p>
                    <Form.Select
                      placeholder="RCP"
                      onChange={(e, { value }) =>
                        this.handleChangePro(value, "rcp")
                      }
                      value={rcp}
                      options={RcpOptions}
                      disabled={this.state.detailed}
                    />
                  </>
                ) : (
                  <>
                    <p>SSP</p>
                    <Form.Select
                      placeholder="SSP"
                      onChange={(e, { value }) =>
                        this.handleChangePro(value, "ssp")
                      }
                      value={ssp}
                      options={RcpOptions}
                    />
                  </>
                )}
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <p>Scenario Type</p>

                <Form.Select
                  placeholder="Scenario Type"
                  onChange={(e, { value }) =>
                    this.handleChangePro(value, "financial")
                  }
                  value={this.state.financial}
                  options={FinanceOptions}
                />
              </Col>

              <Col lg={4}>
                <p>Year</p>
                {this.state.analysis == "rcp" ? (
                  <Form.Select
                    placeholder="Year"
                    onChange={(e, { value }) =>
                      this.handleChangePro(value, "year")
                    }
                    value={year}
                    options={YearOptions}
                    disabled={this.state.detailed}
                  />
                ) : (
                  <Form.Select
                    placeholder="Year"
                    onChange={(e, { value }) =>
                      this.handleChangePro(value, "year")
                    }
                    value={year}
                    options={YearOptions_ssp}
                    disabled={this.state.detailed}
                  />
                )}
              </Col>

              <Col lg={4}>
                <p>Content Type</p>
                <Form.Select
                  placeholder="Content Type"
                  onChange={(e, { value }) =>
                    this.handleChangePro(value, "with_content")
                  }
                  value={this.state.with_content}
                  options={ContentOptions}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={8}>
                <p>
                  Account for Long-term Impact of Climate Change on Economic
                  Growth
                </p>
                <Form.Select
                  placeholder="Additional Factor"
                  onChange={(e, { value }) =>
                    this.handleChangePro(value, "adjusted_gdp")
                  }
                  value={this.state.adjusted_gdp}
                  options={GdpOptions}
                />
              </Col>

              <p>
                Note for *: For the outputs under “Operational Loss Adjusted
                with Long-term Climate Change Impact”, in addition to the
                operational loss due to acute hazards, it includes loss
                associated with the impact from long-term climate change
                (chronic hazards related e.g., raising temperatures on labour
                productivity, long-term sea level rise causing erosion on
                coastline, etc).
              </p>
            </Row>
            <br />

            <br />

            <Button
              onClick={this.handleSubmitPro}
              style={{
                backgroundColor: "#18202F",
                color: "white",
                float: "right",
              }}
            >
              Apply Filter
            </Button>
            <br />
          </Modal.Content>
        </Modal>
        <KeyFindingModals
          card_finding_1={this.state.card_finding_1}
          card_finding_2={this.state.card_finding_2}
          card_finding_3={this.state.card_finding_3}
          card_finding_4={this.state.card_finding_4}
          card_finding_5={this.state.card_finding_5}
          card_finding_6={this.state.card_finding_6}
          key_finding_1={this.state.key_finding_1}
          key_finding_2={this.state.key_finding_2}
          key_finding_3={this.state.key_finding_3}
          key_finding_p={this.state.key_finding_p}
          key_finding_t={this.state.key_finding_t}
          info_table={this.state.info_table}
          toolkit={this.state.toolkit}
          handleCardClose={this.handleCardClose}
          handleKeyClose={this.handleKeyClose}
          key_finding_data={this.state.key_finding_data}
          analysis={this.state.analysis}
          rcp={this.state.rcp}
          ssp={this.state.ssp}
          year={this.state.year}
          overall={this.state.overall}
          losses={this.state.losses}
          hazard={this.state.hazard}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.project.errors,
    project: state.project.list,
    feedback: state.feedback.feedback,
    building: state.feedback.building,
    detailyear: state.feedback.detailyear,
    isLoading: state.feedback.isLoading,
    assets: state.asset.asset,
    summary: state.feedback.summary,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addDashboard: (formdata) => {
      dispatch(dashboard.postDashboard(formdata));
    },
    getProjectList: (physical_risk) => {
      dispatch(project.getProjectList(physical_risk));
    },
    logout: () => {
      dispatch(auth.logout());
    },
    getDetailByYear: (formdata) => {
      dispatch(dashboard.getDetailByYear(formdata));
    },
    getAssets: () => {
      dispatch(asset.getAssets());
    },
    updateAsset: (formdata, callback) =>
      dispatch(asset.updateAsset(formdata, callback)),
    getSummary: (formdata) => {
      dispatch(dashboard.getSummary(formdata));
    },
    sspDashboard: (formdata) => {
      dispatch(dashboard.sspDashboard(formdata));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
